<template>
  <a-select
    :value="value"
    v-bind="$attrs"
    v-on="$listeners"
    show-search
    option-filter-prop="children"
    :filter-option="filterOption"
  >
    <slot />
  </a-select>
</template>

<script>
/**
 * ERP 档案/单据通用可搜索下拉（与客户档案「所属商务」等字段交互一致：show-search + 选项过滤）
 * 必须显式声明 value：在 render(h) 里以 props 传入时，未声明的 prop 不会落到 a-select 上。
 */
export default {
  name: 'ErpSearchSelect',
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: undefined
    }
  },
  methods: {
    filterOption (input, option) {
      const kw = String(input || '').trim().toLowerCase()
      if (!kw) return true
      const label = this.optionText(option).toLowerCase()
      const props = option.componentOptions && option.componentOptions.propsData
      const title = props && props.title ? String(props.title).toLowerCase() : ''
      return label.includes(kw) || (title && title.includes(kw))
    },
    optionText (option) {
      if (!option) return ''
      const children = option.componentOptions && option.componentOptions.children
      if (children && children.length) {
        return children.map(c => (c.text != null ? c.text : '')).join('').trim()
      }
      return ''
    }
  }
}
</script>
